import type { JSX } from 'react';
import { HookFormCheckbox } from 'ts/commons/forms/HookFormCheckbox';
import { FormGroup } from 'ts/components/Form';

/** Values provided by the AssessmentFilter component. */
export type AssessmentFilterValues = {
	includeRedAssessments: boolean;
	includeYellowAssessments: boolean;
};

/**
 * Filter that will only include findings with the selected assessment colors. The component will only work when wrapped
 * in a FormProvider.
 */
export function AssessmentFilter(): JSX.Element {
	return (
		<FormGroup inline as="fieldset">
			<legend>Severity</legend>
			<HookFormCheckbox<AssessmentFilterValues> name="includeRedAssessments" id="red-checkbox" label="Red" />
			<HookFormCheckbox<AssessmentFilterValues>
				name="includeYellowAssessments"
				id="yellow-checkbox"
				label="Yellow"
			/>
		</FormGroup>
	);
}
